<template>
    <div
        :class="['answers', `layout-${ layout }`]"
    >
        <template v-for="option in options">
            <div
                :key="option.value"
                class="onboarding-select"
            >
                <input
                    :id="`answer-${ option.value }`"
                    :ref="option.value"
                    v-model="tmpValue"
                    type="checkbox"
                    :value="option.value"
                    @change="updateValue"
                >
                <label
                    :for="`answer-${ option.value }`"
                >{{ option.label }}
                </label>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        layout: {
            type: String,
            default: '',
        },
        options: {
            type: Array,
            default: () => [],
        },
        label: {
            type: String,
            default: '',
        },
        inputKey: {
            type: String,
            default: 'other',
        },
    },

    data: () => ({
        tmpValue: [],
    }),

    methods: {
        /**
         * Emits 'input' event
         */
        updateValue() {
            this.$emit('input', this.tmpValue);
        },
    },
};
</script>
